module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/.0.15.3@axios/index.js
// module id = 1
// module chunks = 2